import React from "react";
import { useOutletContext } from "react-router-dom";
import { SecurityPanel } from "../components/security-panel.jsx";
import type { AdminOutletContext } from "../lib/outlet-context";

export function InfrastructureSecurityPage() {
  const { clients, api } = useOutletContext<AdminOutletContext>();
  return <SecurityPanel clients={clients} api={api} />;
}
